export default __webpack_public_path__ + "static/media/team1.e6ef376d.jpeg";